import moment from 'moment'

import { TimeRange } from 'models'

export const convertDateRange = (range) => {
  if (!range) {
    return {
      startsAt: moment.utc().subtract(12, 'months').startOf('month').toISOString(),
      endsAt: moment.utc().subtract(1, 'months').endOf('month').toISOString()
    }
  }
  let startsAt
  let endsAt = moment.utc().endOf('day')
  switch (range) {
    case TimeRange.Today:
      startsAt = moment.utc().startOf('day')
      break
    case TimeRange.LastSevenDays:
      startsAt = moment.utc().subtract(7, 'days').startOf('day')
      break
    case TimeRange.LastFourteenDays:
      startsAt = moment.utc().subtract(14, 'days').startOf('day')
      break
    case TimeRange.LastThirtyDays:
      startsAt = moment.utc().subtract(30, 'days').startOf('day')
      break
    case TimeRange.LastMonth:
      startsAt = moment.utc().subtract(1, 'month').startOf('month')
      endsAt = moment.utc().subtract(1, 'month').endOf('month')
      break
    case TimeRange.LastThreeMonths:
      startsAt = moment.utc().subtract(3, 'months').startOf('month')
      endsAt = moment.utc().subtract(1, 'month').endOf('month')
      break
    case TimeRange.LastSixMonths:
      startsAt = moment.utc().subtract(6, 'months').startOf('day')
      break
    case TimeRange.LastTwelveMonths:
      startsAt = moment.utc().subtract(12, 'months').startOf('day')
      break
    case TimeRange.LastYear:
      startsAt = moment.utc().startOf('year')
      break
    case TimeRange.LastThreeYears:
      startsAt = moment.utc().subtract(3, 'years').startOf('day')
      break
    case TimeRange.LastFiveYears:
      startsAt = moment.utc().subtract(5, 'years').startOf('day')
      break
    case TimeRange.LastTenYears:
      startsAt = moment.utc().subtract(10, 'years').startOf('day')
      break
    default:
      startsAt = moment.utc().subtract(12, 'months').startOf('month')
      break
  }
  
  return {
    startsAt: startsAt.toISOString(),
    endsAt: endsAt.toISOString()
  }
}

export const getScale = (range) => {
  switch (range) {
    case TimeRange.Today:
    case TimeRange.LastSevenDays:
    case TimeRange.LastFourteenDays:
    case TimeRange.LastThirtyDays:
    case TimeRange.LastMonth:
      return 'day'
    case TimeRange.LastThreeMonths:
    case TimeRange.LastSixMonths:
    case TimeRange.LastTwelveMonths:
    case TimeRange.LastYear:
    case TimeRange.LastThreeYears:
      return 'month'
    case TimeRange.LastFiveYears:
    case TimeRange.LastTenYears:
      return 'year'
    default:
      return 'month'
  }
}